import { combineObjectWithoutCloning } from "@helpers/_functions";

export const documentationReducer = {
  initialState: {
    listFolder: [],
    listEmployeFolder: [],
    organigram: {
      children: [],
      isLoaded: false,
      isDataOutdated: false,
      isLoading: false,
      isRefreshing: false
    },
    documentTemplates: {
      isLoaded: false,
      list: []
    }
  },
  handlers: {
    "documentation/SET_LIST_FOLDER": (state, payload) =>
      combineObjectWithoutCloning(state, { listFolder: payload }),
    "documentation/SET_LIST_EMPLOYE_FOLDER": (state, payload) =>
      combineObjectWithoutCloning(state, { listEmployeFolder: payload }),
    "documentation/SET_ORGANIGRAM": (state, payload) =>
      combineObjectWithoutCloning(state, { organigram: payload }),
    "documentation/SET_DOCUMENT_TEMPLATES": (state, payload) =>
      combineObjectWithoutCloning(state, { documentTemplates: payload }),
    "RESET_ALL": () => documentationReducer.initialState
  }
};

export default documentationReducer;
